var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 841.89 595.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2,.cls-4,.cls-5,.cls-6{opacity:0.6;}.cls-3{fill:#a9b9d3;}.cls-4,.cls-5,.cls-6{mix-blend-mode:soft-light;}.cls-4{fill:url(#linear-gradient);}.cls-5{fill:url(#linear-gradient-2);}.cls-6{fill:url(#linear-gradient-3);}.cls-7{fill:#252530;}.cls-8{fill:#444;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 66.49,
    y1: 344.29,
    x2: 468.66,
    y2: 344.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001a5a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 278.22,
    y1: 101.21,
    x2: 335.93,
    y2: 101.21,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 255.77,
    y1: 61.13,
    x2: 278.22,
    y2: 61.13,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 267.58,
    cy: 344.29,
    r: 201.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 267.58,
    cy: 344.29,
    r: 201.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 307.07,
    cy: 101.21,
    r: 28.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 307.07,
    cy: 101.21,
    r: 28.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 266.99,
    cy: 61.13,
    r: 11.22
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 266.99,
    cy: 61.13,
    r: 11.22
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M108.22,313.29h6.58V393h-6.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M133.92,340.69c6.06-3.71,15.41-6.16,24.33-6.16,13.49,0,26.24,5.53,26.24,20.29v24.75c0,4.78,1.17,6.8,6.16,6.8h.74V393c-8.81,0-13.49-3.83-13.49-13.49v-2.23c-5.84,9.77-18.48,15.72-30.7,16.25-13.06.53-19.33-7-19.33-15.19,0-9.24,8.07-19.23,23.58-18.91l16.78.21c3,0,9.25.32,9.67-3.72-.21-11-9.35-15.08-19.33-15.08-7.76,0-16,2.44-21.25,5.63Zm33.68,25.5-16-.21c-10.94-.22-17.21,6.48-17.21,12.32,0,4.88,4.25,9.13,13.49,8.6,12.32-.74,29.64-10.2,30.06-22.41v-.64C175.56,365.87,172,366.3,167.6,366.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M236.64,393V352.7c-.11-2-.43-4.25-2.66-4.25h-2.44V335.59h2.55c5.42,0,18.06,0,19.76,7.65a18.34,18.34,0,0,1,15.93-8.81c10.52,0,17.1,3.71,20.4,11.15,2.33-6.05,7.43-11.15,17.1-11.15,15.72,0,22.73,8.18,22.73,24.75v14.13c0,4.78,1.06,6.9,6.06,6.9h.74V393c-8.92,0-24.33.53-24.33-13.49V362.36c0-9.87-2.76-14.76-9.66-14.76-6.38,0-9.88,5.1-10.31,14.13V393H275v-30.6c0-9.87-3-14.76-10-14.76s-10.94,5.95-10.83,16.68l-.11-.11V393Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M346.79,340.69c6.06-3.71,16.78-6.58,27.09-6.58,14.34,0,28,5.42,27.94,21.67L401.71,373v.32c0,4.78.53,6.79,5.52,6.79H408V393c-14.24,0-22.52-1.49-23.59-10.62-4.35,7-13.17,11-24.32,11.15-12.32.21-18.38-7.33-18.38-15.51,0-10,8.82-20.93,25.81-20.29l9.35.21c2.87.11,7.12.11,7.44-3.08v-.21c0-4.46-4.78-6.06-10.84-6.06-8.28,0-19.12,3-23.05,5.42Zm29.85,29.54-8.71-.11c-4.89-.11-7.54,2.76-7.54,5.42,0,2.44,2.23,4.67,7,4.56,5.31-.31,16.57-3.08,16.89-11.47v-.42A13,13,0,0,1,376.64,370.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M416.79,393V352.7c-.11-2-.42-4.25-2.66-4.25h-2.44V335.59h2.55c5.74,0,20,0,20,9.57v.1c3.93-6.05,9.78-10.51,17.85-10.51a29.05,29.05,0,0,1,12.53,3.18l-4,13.17a22,22,0,0,0-7.76-1.27c-8.71,0-18.59,4.14-18.59,13.49V393Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M473.51,393V352.7c-.1-2-.42-4.25-2.65-4.25h-2.45V335.59H471c5.42,0,18.06,0,19.76,7.65a18.37,18.37,0,0,1,15.94-8.81c10.51,0,17.1,3.71,20.39,11.15,2.34-6.05,7.44-11.15,17.1-11.15,15.72,0,22.74,8.18,22.74,24.75v14.13c0,4.78,1.06,6.9,6.05,6.9h.75V393c-8.93,0-24.33.53-24.33-13.49V362.36c0-9.87-2.76-14.76-9.67-14.76-6.37,0-9.88,5.1-10.3,14.13V393H511.86v-30.6c0-9.87-3-14.76-10-14.76s-10.94,5.95-10.83,16.68l-.11-.11V393Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M612.88,394.66c-15.3,0-33.25-10-33.25-30.49s18-30.49,33.25-30.49,33.14,10,33.14,30.49S628.17,394.66,612.88,394.66Zm0-44.83c-7.23,0-15.72,4.67-15.72,14.34s8.49,14.34,15.72,14.34,15.72-4.78,15.72-14.34S620.1,349.83,612.88,349.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M678.2,323.27v12.32h23.27v12.65H678.2v22.41c0,5,1.28,10,9,10,5.1,0,9.24-2.33,12.64-6.05l4.36,12.64a28.42,28.42,0,0,1-19.65,8.61c-13.6,0-23.8-5.63-23.8-20.61v-27l-9.88.1V335.59h9.88l6.59-12.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M714.21,340.69c6.06-3.71,16.78-6.58,27.09-6.58,14.34,0,28,5.42,27.94,21.67L769.13,373v.32c0,4.78.53,6.79,5.52,6.79h.75V393c-14.24,0-22.52-1.49-23.59-10.62-4.35,7-13.17,11-24.32,11.15-12.32.21-18.38-7.33-18.38-15.51,0-10,8.82-20.93,25.82-20.29l9.34.21c2.87.11,7.12.11,7.44-3.08v-.21c0-4.46-4.78-6.06-10.84-6.06-8.28,0-19.12,3-23,5.42Zm29.85,29.54-8.71-.11c-4.89-.11-7.54,2.76-7.54,5.42,0,2.44,2.23,4.67,7,4.56,5.31-.31,16.57-3.08,16.89-11.47v-.42A13,13,0,0,1,744.06,370.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M265.72,440.78v4a15.89,15.89,0,0,1-5.83.95c-5.18,0-7.28-2.69-7.28-8v-8.91h-3.17v-4.31h3.29l1.3-5.23h3.45v5.23h7.84v4.31h-7.84v8.4c0,3.17,1.07,4.39,4,4.39A11.74,11.74,0,0,0,265.72,440.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M287.77,424.51V445.3h-4.16l-.27-2a9.73,9.73,0,0,1-6.82,2.57c-5.34,0-7.36-2.61-7.36-8.59V424.51H274v12.35c0,3.37,1.15,4.71,3.68,4.71a6.71,6.71,0,0,0,5.15-2.41V424.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M302.78,415.6h4.91v29.7h-4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M330.1,432.66V445.3h-4.16l-.28-1.75a9.84,9.84,0,0,1-6.89,2.38c-4.35,0-6.89-2.38-6.89-6.3s3-6.49,7.84-6.49a16.68,16.68,0,0,1,5.47.79v-1.62c0-2.89-1.47-4.16-4.95-4.16a15.91,15.91,0,0,0-6.54,1.27v-4.28a20.65,20.65,0,0,1,7.21-1.27C327.52,423.87,330.1,426.61,330.1,432.66Zm-4.91,7.49v-2.89a15.57,15.57,0,0,0-4.4-.72c-2.53,0-4,.88-4,2.86s1.43,2.77,3.41,2.77A6.68,6.68,0,0,0,325.19,440.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M354.53,424.51,346,445.3h-4.8l-8.51-20.79h5.47l2.89,8c.91,2.41,1.82,4.95,2.65,7.92.83-3,1.74-5.51,2.65-8l2.89-7.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M374,432.66V445.3h-4.16l-.27-1.75a9.86,9.86,0,0,1-6.89,2.38c-4.36,0-6.89-2.38-6.89-6.3s3-6.49,7.84-6.49a16.62,16.62,0,0,1,5.46.79v-1.62c0-2.89-1.46-4.16-5-4.16a15.86,15.86,0,0,0-6.53,1.27v-4.28a20.61,20.61,0,0,1,7.21-1.27C371.44,423.87,374,426.61,374,432.66Zm-4.91,7.49v-2.89a15.5,15.5,0,0,0-4.39-.72c-2.54,0-4,.88-4,2.86s1.42,2.77,3.4,2.77A6.67,6.67,0,0,0,369.1,440.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M398.8,432.51V445.3h-4.91V432.9c0-3.33-1.5-4.83-4.28-4.83a6.9,6.9,0,0,0-5.14,2.42V445.3h-4.91V424.51h4.15l.36,1.94a9.52,9.52,0,0,1,6.73-2.58C396.27,423.87,398.8,426.88,398.8,432.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M423,415.6v29.7h-4.15l-.28-2.1a9.36,9.36,0,0,1-6.73,2.69c-5.47,0-8.71-3.45-8.71-10.77,0-7.13,4.27-11.25,10.45-11.25a14.1,14.1,0,0,1,4.55.6V415.6Zm-4.87,23.6V428.7a14.41,14.41,0,0,0-4.27-.63c-3.65,0-5.78,2.34-5.78,6.85s1.66,6.77,4.87,6.77A6.43,6.43,0,0,0,418.16,439.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M446.87,433.93c0,.87,0,1.66,0,2.5H432.5c.47,3.56,2.61,5.38,6.69,5.38a16.22,16.22,0,0,0,6.65-1.27v4.12a20.43,20.43,0,0,1-7.48,1.23c-7,0-10.77-4-10.77-10.85s3.8-11.17,10.17-11.17C443.43,423.87,446.87,427.2,446.87,433.93Zm-14.29-1h9.62c-.16-3.48-1.82-4.95-4.52-4.95S433.09,429.61,432.58,432.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M463.9,424.11v4.75a6.08,6.08,0,0,0-2.14-.27,6.36,6.36,0,0,0-5.43,3.2V445.3h-4.91V424.51h4.16l.44,2.37a7.66,7.66,0,0,1,6.06-3A6.52,6.52,0,0,1,463.9,424.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M464.85,419.28l7.6-6.81,2.85,3.84-8.2,5.94Zm2.69,5.23h4.91V445.3h-4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M494.86,432.66V445.3H490.7l-.27-1.75a9.86,9.86,0,0,1-6.89,2.38c-4.36,0-6.89-2.38-6.89-6.3s3-6.49,7.84-6.49a16.66,16.66,0,0,1,5.46.79v-1.62c0-2.89-1.46-4.16-4.95-4.16a15.86,15.86,0,0,0-6.53,1.27v-4.28a20.59,20.59,0,0,1,7.2-1.27C492.29,423.87,494.86,426.61,494.86,432.66ZM490,440.15v-2.89a15.5,15.5,0,0,0-4.39-.72c-2.54,0-4,.88-4,2.86s1.42,2.77,3.4,2.77A6.68,6.68,0,0,0,490,440.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M508.36,435c0-6.77,4.08-11.13,10.69-11.13s10.58,4.2,10.58,10.89-4.12,11.13-10.73,11.13S508.36,441.73,508.36,435Zm16.32-.12c0-4.35-2.18-6.81-5.71-6.81s-5.7,2.5-5.7,6.81,2.22,6.81,5.7,6.81S524.68,439.2,524.68,434.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M553.38,432.51V445.3h-4.91V432.9c0-3.33-1.5-4.83-4.27-4.83a6.92,6.92,0,0,0-5.15,2.42V445.3h-4.91V424.51h4.16l.35,1.94a9.53,9.53,0,0,1,6.74-2.58C550.85,423.87,553.38,426.88,553.38,432.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M559,415.6h4.91v29.7H559Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M568.9,417.46a3.23,3.23,0,1,1,3.21,3.09A3,3,0,0,1,568.9,417.46Zm.76,7.05h4.91V445.3h-4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M599.59,432.51V445.3h-4.91V432.9c0-3.33-1.5-4.83-4.27-4.83a6.9,6.9,0,0,0-5.15,2.42V445.3h-4.91V424.51h4.16l.35,1.94a9.52,9.52,0,0,1,6.73-2.58C597.06,423.87,599.59,426.88,599.59,432.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M623.23,433.93c0,.87,0,1.66,0,2.5H608.86c.47,3.56,2.61,5.38,6.69,5.38a16.22,16.22,0,0,0,6.65-1.27v4.12a20.43,20.43,0,0,1-7.48,1.23c-7,0-10.77-4-10.77-10.85s3.8-11.17,10.17-11.17C619.79,423.87,623.23,427.2,623.23,433.93Zm-14.29-1h9.62c-.16-3.48-1.82-4.95-4.52-4.95S609.45,429.61,608.94,432.94Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9219b915b5064baf536ab3676fa90ed4.svg";
export { ForwardRef as ReactComponent };